// Farbcodierter Index der Kennzahlen-Sektionen.
//
// Eigene Datei (wie `scopeColors.ts`), damit die Eindeutigkeit der Palette ohne
// React/Fluent prüfbar bleibt — im Reiter stand die Tabelle zwischen 2000 Zeilen
// Render-Code, und dass zwei Sektionen dieselbe Farbe trugen, fiel niemandem auf.

import { REFINED } from "../risikoanalyseStep/tokens";

/**
 * Akzentfarbe je Sektion — ausschließlich als 3px-Balken links an der
 * Label-Zelle und als Icon-Farbe.
 *
 * Bewusst NIE als Flächenfüllung: zehn gefärbte Bänder würden miteinander um
 * die Aufmerksamkeit konkurrieren, statt einen ruhigen farbcodierten Index zu
 * bilden. Als schmale Kante bleibt die Farbe ein Wiedererkennungsmerkmal beim
 * Scrollen.
 *
 * Jede Sektion braucht ihren EIGENEN Ton, ohne Ausnahme für „liegt ja weit
 * auseinander": der Reiter startet mit allen Sektionen zugeklappt (und „Alle
 * zuklappen" stellt genau das wieder her). Dann stehen alle zehn Zeilen
 * gleichzeitig im Bild, und ein doppelt vergebener Ton macht aus dem Index zwei
 * verwechselbare Zeilen.
 */
export const SECTION_ACCENT: Record<string, string> = {
  umsatz: "#7d2169",
  wareneinsatz: "#a16207",
  rohertrag: "#15803d",
  beschaeftigte: "#0f4c81",
  // Olivgrün — der einzige noch freie Farbton-Bereich (zwischen dem Amber des
  // Wareneinsatzes und dem Grün des Rohertrags liegen je rund 40°). Vorher teilte
  // sich die Sektion das Rostbraun mit „Verpflichtungen".
  bruttolohn: "#4d7c0f",
  rendite: "#f0a020",
  eigenkapital: "#5b21b6",
  liquiditaet: "#0d9488",
  verpflichtungen: "#9a3412",
  buergschaften: "#0e7490",
};

export const accentOf = (sectionId: string): string => SECTION_ACCENT[sectionId] ?? REFINED.aub;
